<script setup lang="ts">
  import { formatNumber } from '#shared/formatters/number';
  import { useUiStore } from '~/store/ui';

  const emit = defineEmits<{ click: [] }>();
  const { store } = useVipFeature();
  const uiStore = useUiStore();

  const currentTier = computed(() => store.value?.currentTier);
  const getUserProgressBarWidth = computed(() => store.value?.getUserProgressBarWidth);
  const getPointsToNextUserTier = computed(() => store.value?.getPointsToNextUserTier);
  const getUserNextTierId = computed(() => store.value?.getUserNextTierId);

  const isCompactView = computed(() => !uiStore.sidebarIsOpen);
  const starSize = computed(() => (isCompactView.value ? 40 : 48));
  function handleClick() {
    navigateTo('/vip-club');
    emit('click');
  }
</script>

<template>
  <div
    class="flex w-full p-[10px] items-start gap-[6px] rounded-[6px] bg-white/5 cursor-pointer hover:outline-1"
    :class="{ 'flex-col gap-2': isCompactView }"
    @click="handleClick"
  >
    <VipStar :tier="currentTier" :size="starSize" />

    <div v-if="isCompactView" class="h-1 w-full basis-full rounded-[10px] bg-white/10">
      <div
        class="h-1 transition-[width] duration-200 ease-in-out rounded-[10px] bg-[#0080ff]"
        :style="{ width: getUserProgressBarWidth }"
      />
    </div>
    <div v-else class="flex grow flex-col gap-2.5 basis-full font-barlow text-white text-nowrap">
      <p
        v-if="getUserProgressBarWidth === '100%' || !getPointsToNextUserTier"
        class="text-[15px] font-bold leading-[150%]"
      >
        My VIP Progress
      </p>
      <p v-else-if="getPointsToNextUserTier" class="text-[15px] leading-[150%]">
        <strong>{{ formatNumber(getPointsToNextUserTier) }}</strong>
        more points to
        <span
          class="capitalize bg-[linear-gradient(180deg,_#8dc2f6_0%,_#4986c2_100%)] bg-clip-text text-transparent font-medium leading-[150%]"
        >
          {{ getUserNextTierId }}
        </span>
      </p>

      <div class="w-full h-2.5 rounded-[10px] bg-white/10 overflow-hidden">
        <div
          class="h-2.5 transition-[width] duration-200 ease-in-out rounded-[10px] bg-[#0080ff]"
          :style="{ width: getUserProgressBarWidth }"
        />
      </div>
    </div>
  </div>
  <div class="h-[1px] w-full bg-white/10 my-[18px]" />
</template>
